import React, {useEffect, useState, useRef} from 'react';
import Button from '../../../components/Button/Button';
import {Col, Container, Alert, Row, UncontrolledPopover, FormGroup, Label, Input, Modal, ModalHeader, ModalBody} from 'reactstrap';
import {useTranslation, Trans} from 'react-i18next';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import axios from '../../../config/axios-interceptor';
import {requestSchema} from '../../../utils/validationSchemas';

interface IRequestQuoteModal {
  companyId: Number;
  isRequestQuoteModalOpen: boolean;
  toggleRequestQuoteModal: Function;
}

const RequestQuoteModal = ({ isRequestQuoteModalOpen, toggleRequestQuoteModal, companyId }: IRequestQuoteModal) => {
  const {t} = useTranslation();

  const [errorMessage, setErrorMessage] = useState('');

  const {register, handleSubmit, errors, setValue} = useForm({
    resolver: yupResolver(requestSchema)
  });

  const onSubmit = data => {
    console.log(data)
    const postData = {
      companyId,
      userName: data.requestName,
      userEmail: data.requestEmail,
      userPhoneNumber: data.requestPhone,
      userSubject: data.requestSubject,
      userMessage: data.requestMessage
    }

    requestQuote(postData);
  }

  const requestQuote = async (postData) => {
    try {
      const response = await axios.post('Utility/RequestCompanyOffer', postData);
      if(response.status !== 200) {
        setErrorMessage('Something went wrong!');
        return;
      }
      toggleRequestQuoteModal();
    }
    catch(error) {
      setErrorMessage('Something went wrong!');
    }
  }

  return (
    <Modal isOpen={isRequestQuoteModalOpen} toggle={toggleRequestQuoteModal} contentClassName="border-0"
      style={{boxShadow: '0px 0px 10px 0px #80C32D', border: '2px solid #80C32D', borderRadius: '6px'}}>
    <ModalHeader toggle={toggleRequestQuoteModal} style={{border: 'none'}}></ModalHeader>
      <ModalBody className="pb-2 ml-3 pt-0 mr-4">
        <div className="text-center">
          <h4 className="text-center font-weight-bolder mb-4">{t('boothRequest')}</h4>
          <p className="text-center font-weight-lighter">{t('boothNetworking')}</p>
          <form>
            <FormGroup>
              <FormGroup row>
                <Label for="Name" sm={2}>{t('boothNameInput')}</Label>
                <Col sm={10}>
                  <input className="form-control" type="text" name="requestName" ref={register}
                          onChange={e => setValue('requestName', e.currentTarget.value)}
                          placeholder={t('boothNameInput')}/>
                  {errors.requestName &&
                  <div className="text-danger text-left small mx-2">{errors.requestName?.message}</div>}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="Email" sm={2}>{t('boothEmailInput')}</Label>
                <Col sm={10}>
                  <input className="form-control" type="email" name="requestEmail" id="requestEmail" ref={register}
                          onChange={e => setValue('requestEmail', e.currentTarget.value)}
                          placeholder={t('boothEmailInput')}/>
                  {errors.requestEmail &&
                  <div className="text-danger text-left small mx-2">{errors.requestEmail?.message}</div>}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="phoneNumber" sm={2}>{t('boothPhoneInput')}</Label>
                <Col sm={10}>
                  <input className="form-control" type="text" name="requestPhone" id="requestPhone" ref={register}
                          onChange={e => setValue('requestPhone', e.currentTarget.value)}
                          placeholder={t('boothPhoneInput')}/>
                  {errors.requestPhone &&
                  <div className="text-danger text-left small mx-2">{errors.requestPhone?.message}</div>}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="Subject" sm={2}>{t('boothSubjectInput')}</Label>
                <Col sm={10}>
                  <input className="form-control" type="text" name="requestSubject" id="requestSubject" ref={register}
                          onChange={e => setValue('requestSubject', e.currentTarget.value)}
                          placeholder={t('boothSubjectInput')}/>
                  {errors.requestSubject &&
                  <div className="text-danger text-left small mx-2">{errors.requestSubject?.message}</div>}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="Message" sm={2}>{t('boothMessageInput')}</Label>
                <Col sm={10}>
                  <Input className="form-control" type="textarea" name="requestMessage" id="requestMessage" ref={register}
                          onChange={e => setValue('requestMessage', e.currentTarget.value)}
                          placeholder={t('boothMessageInput')}/>
                  {errors.requestMessage &&
                  <div className="text-danger text-left small mx-2">{errors.requestMessage?.message}</div>}
                </Col>
              </FormGroup>

              <Button onClick={handleSubmit(onSubmit)}
                      className="mt-1 mb-2 rounded"
                      type="primary"
                      text={t('boothRequest')}/>
              {errorMessage &&
              <Alert color="danger" className="w-100 mx-auto mt-4 mb-0" style={{maxWidth: '350px'}}>
                {errorMessage}
              </Alert>}
            </FormGroup>
          </form>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default RequestQuoteModal;